<template>
  <div class="content1 contentPage swiper-slide" :class="nowPage === 0 && loadEnd ? 'cartoon' : ''">
    <img :src="logoImg" alt="logoImg" class="logoImg" @click="toGuanWang">
    <div class="mainImgWrap centerFlex">
      <img :src="titleTxtImg" class="titleTxtImg">
      <img :src="mainImg" class="mainImg">
      <div class="rightImg">
        <img :src="rightTxt1" class="rightTxt1">
        <img :src="rightTxt2" class="rightTxt2">
      </div>
    </div>
    <div class="bottomTxtImg centerFlex">
      <img :src="bottomTitle1" class="bottomTitle1">
      <span class="heng"></span>
      <img :src="bottomTitle2" class="bottomTitle2">
    </div>
  </div>
</template>

<script>
import { swiperMixin } from '@/utils/mixin.js'
import logoImg from '@/assets/img/logo.png'
import titleTxtImg from '@/assets/img/content1/titleTxt.png'
import mainImg from '@/assets/img/content1/mainImg.png'
import rightTxt1 from '@/assets/img/content1/rightTxt1.png'
import rightTxt2 from '@/assets/img/content1/rightTxt2.png'
import bottomTitle1 from '@/assets/img/content1/bottomTitle1.png'
import bottomTitle2 from '@/assets/img/content1/bottomTitle2.png'


export default {
  mixins: [swiperMixin],
  props: {
    loadEnd: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      logoImg,
      titleTxtImg, // 从龙到鸟的演化之旅
      mainImg, // 腾飞之龙
      rightTxt1,
      rightTxt2,
      bottomTitle1,
      bottomTitle2,
    }
  },
  computed: {
    nowPage () {
      return this.$store.state.nowPage
    }
  },
  methods: {
    toGuanWang () {
      window.open('http://www.czmuseum.com','_blank') // 新窗口打开外链接
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/app.styl'
@import '../../stylus/animation.styl'
@import './content1.styl'
</style>